import React from 'react';

/**
 * Column headers for activity table
 * Static headers showing the columns for activities
 */
export const ActivityHeaders: React.FC = () => {
    return (
        <div className="activity-headers">
            <div className="activity-header-cell">Aktivitet</div>
            <div className="activity-header-cell">Intervall</div>
            <div className="activity-header-cell">Mängd</div>
            <div className="activity-header-cell">Nästa gång</div>
            <div className="activity-header-cell">Kostnad</div>
        </div>
    );
};
